import React from 'react';
import { observer } from 'mobx-react';
import { MeasureResultsModel } from './MeasureResultsModel';
import './MeasureTool.scss';

interface IMeasureClearCommandViewProps {
  measureResults: MeasureResultsModel;
}

export const MeasureClearCommandView = observer(function (props: IMeasureClearCommandViewProps) {
  return (
    <button
      className="esri-widget--button esri-interactive esri-icon-trash widget-button"
      title="Clear Measurements"
      onClick={async (e) => {
        props.measureResults.clearResults();
      }}
    ></button>
  );
});
